import { composeWithDevTools } from 'redux-devtools-extension';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import * as ReduxPersist from 'redux-persist-immutable';
import { combinedStore } from '../../../reducers';
import { cleanProgress } from '../../../actions/Simulation/ProgressAction';
import Immutable from 'immutable';

export const initStore = (sentryReduxEnhancer: any) => {
  const composeEnhancers = composeWithDevTools({ trace: true }) as any;
  const enhansers = [applyMiddleware(thunk), sentryReduxEnhancer, ReduxPersist.autoRehydrate()].filter(Boolean);

  const store = createStore(combinedStore, composeEnhancers(...enhansers));

  const onComplete = () => {
    store.dispatch(cleanProgress());
  };

  ReduxPersist.persistStore(store, { whitelist: ['editor', 'simulation'] }, onComplete);

  return store;
};

export const initTestingStore = (initialState?: any) => {
  const state = initialState ? Immutable.fromJS(initialState) : undefined;
  const store = createStore(combinedStore, state as any, applyMiddleware(thunk));

  return store;
};

export { useAppDispatch } from './useAppDispatch';

export type { AppThunk } from './types';
export type { AppDispatch } from './types';
export type { RootState } from './types';
export type { GetState } from './types';
